// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Email({ value }) {
  return (
    <div className="email--backend--container">
      <a className="email--backend" href={`mailto:${value}`}>{value}</a>
    </div>
  );
}

Email.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Email;
